<script>
	export let title = 'Default Title';
</script>

<div class="main-title">
	<h2>{title}</h2>
</div>
